<div tabindex="0" pRipple (click)="onClick.emit($event)" class="overlay-toggler">
  <i class="text-color" [ngClass]="$icon()"></i>
  @if (!!$amount()) {
    <osp-badge class="overlay-toggler__badge" badgeSeverity="danger" [value]="$amount() ?? ''" />
  }
</div>
